import React from "react";
import { Clock, Wallet, TrendingDown, Eye } from "lucide-react";

const pains = [
  { icon: Clock, title: "No time to post.", body: "You're running a business — not babysitting Instagram." },
  { icon: Wallet, title: "Can't afford an agency.", body: "$500–$1,500/mo for a social media manager? Hard pass." },
  { icon: TrendingDown, title: "Your feed is dying.", body: "Empty profiles = invisible business. Customers scroll past you." },
  { icon: Eye, title: "Your competitor is winning.", body: "While you 'figure it out,' they're posting daily and stealing your leads." },
];

export const Pain = () => {
  return (
    <section className="py-20 md:py-28 relative" data-testid="pain-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="pill" data-testid="pain-pill">The Problem</span>
          <h2 className="mt-5 font-display font-bold text-white text-4xl sm:text-5xl tracking-tighter">
            Every day you don't post, you're <span className="text-[#3B9EFF]">handing customers</span> to someone else.
          </h2>
          <p className="mt-5 text-lg text-[#A0AABF]">
            You know you need to be on social. But between running the business, serving clients, and chasing payments — content is the first thing to drop.
          </p>
        </div>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {pains.map((p, i) => (
            <div key={i} className="snap-card" data-testid={`pain-card-${i}`}>
              <div className="w-11 h-11 rounded-md bg-[#3B9EFF]/10 border border-[#3B9EFF]/30 flex items-center justify-center text-[#3B9EFF]">
                <p.icon size={20} />
              </div>
              <h3 className="mt-5 font-display text-xl font-bold text-white">{p.title}</h3>
              <p className="mt-2 text-[#A0AABF] text-sm leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pain;
